export const GET_WORDBOARDS = 'GET_WORDBOARDS';

export default {
  GET_WORDBOARDS,
};



// WEBPACK FOOTER //
// ./src/store/modules/wordboard/mutation-types.js